import { useQuery } from 'react-query';
import { queryCommercialEmail } from './useCommercialEmail.query';
import { Commercial } from '../../../types/api/endpoints/commercial/commercial.types';

export const COMMERCIAL_EMAIL_QUERY_KEY = 'ALL_COMMERCIAL_EMAIL';

export const useCommercialEmail = (commercialId: number) => {
  return useQuery<Pick<Commercial, 'email'>, Error>(COMMERCIAL_EMAIL_QUERY_KEY, () => queryCommercialEmail(commercialId));
};
